import { jwtDecode } from "jwt-decode";
import * as React from "react";
import { JwtManager } from "./JwtManager";

interface ManagedSurveysClaims {
  UserName: string;
}

export class TokenHelper extends React.PureComponent {
  tokenManager = new JwtManager({});

  get token(): string | null {
    return this.tokenManager.getToken();
  }

  tokenIsValid(): boolean {
    var expiry = this.tokenManager.getExpires();
    if (!this.token || this.token.length === 0 || (expiry && new Date() > expiry)) {
      return false;
    }
    return true;
  }

  tokenExpiryIsValid(): boolean {
    var expiry = this.tokenManager.getExpires();
    return expiry && new Date() > expiry ? false : true;
  }

  /**
   * Gets the username of the current logged-in user from the token.
   */
  getUsername(): string | undefined {
    if (!this.token) {
      return undefined;
    }

    const claims = jwtDecode<ManagedSurveysClaims>(this.token);
    return claims?.UserName;
  }

  /**
   * Check if the manager has access to a refresh token.
   */
  refreshTokenExists(): boolean {
    return this.tokenManager.getRefreshToken() != null;
  }
}
